/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: constants.ts (Queue Profiles Constants)
 🗓️ Created: 2025-01-05
 🧩 Description:
    Constants and default values for Queue Profiles module.

 🔧 Notes:
    - Centralized constants for better maintainability
    - Default form state values
    - Known settings keys

 🔁 Last Updated: 2025-01-05 by Rodrigo Cuadra
────────────────────────────────────────────────────────────────*/

import { QueueProfileFormState } from '../queueProfiles/types';

export const KNOWN_SETTINGS_KEYS = new Set([
  'caller_exit_destination',
  'ringback_tone',
  'announce_wrap_up_message',
  'announce_resume_playback',
  'ringback_before_moh',
  'agent_whisper',
  'tier_rules_apply',
  'tier_rule_wait',
  'tier_rule_multiply_level',
  'tier_rule_no_agent_no_wait',
  'tier_rule_max_wait',
  'tier_wait_stop_sound',
  'tier_rule_level_stop_sound',
  'tier_skip_busy_agents',
  'tier_randomize_agents',
  'reserve_agents',
  'truncate_tiers_on_load',
  'tier_no_wait',
  'tier_agent_no_wait',
  'tier_retry_wait',
  'tier_rule_retry_wait',
  'tier_agent_retry_wait',
  'member_delay',
  'member_timeout',
  'truncate_agents_on_load',
  'log_debug_info',
  'strict_retry',
  'skip_agents_with_active_call',
  'agent_cooldown',
  'agent_busy_delay_time',
  'agent_reject_delay_time',
  'max_wait_size',
  'ring_progressively',
  'skip_call_caller_id_number'
]);

export const DEFAULT_FORM_STATE: QueueProfileFormState = {
  // General
  queueProfileName: '',
  
  // Advanced Queue Logic
  memberDelay: '2',
  memberTimeout: '60',
  truncateAgentsOnLoad: false,
  logDebugInfo: false,
  strictRetry: false,
  skipAgentsWithActiveCall: false,
  agentCooldownTime: '0',
  agentBusyDelay: '0',
  agentRejectDelay: '0',
  maxWaitSize: '0',
  ringProgressively: false,
  skipCallerIdNumber: '',
  
  // Caller Experience / Announcements
  callerExitDestination: '',
  ringbackTone: '${us-ring}',
  announceWrapUpMessage: '',
  announceResumePlayback: false,
  playRingbackBeforeMOH: false,
  agentWhisperTone: '',
  
  // Tier Rules
  tierRulesApply: false,
  tierRuleWait: '5',
  tierRuleMultiplyLevel: true,
  tierRuleNoAgentNoWait: true,
  tierRuleMaxWait: '0',
  tierWaitStopSound: '',
  tierRuleLevelStopSound: '',
  tierSkipBusyAgents: false,
  tierRandomizeAgents: false,
  reserveAgents: false,
  truncateTiersOnLoad: false,
  tierNoWait: false,
  tierAgentNoWait: false,
  tierRetryWait: '0',
  tierRuleRetryWait: '0',
  tierAgentRetryWait: '0',
  
  createdAt: null,
  updatedAt: null
};

